export enum SameFileDetectedEnum {
    'extend' = 'extend',
    'overwrite' = 'overwrite',
    'dontimport' = 'dontimport'
}
